import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { actionSell } from "../../http/coinAPI";

export const fetchSell = createAsyncThunk(
    'coin/fetchSell',
    async function ({ game, server, coins, amount }, { rejectWithValue, dispatch }) {
        dispatch(clearErrors())

        try {
            const data = await actionSell(game, server, coins, amount)
            return data

        } catch (error) {
            // если есть ответ от сервера
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); 
            }
            return rejectWithValue({ message: error.message || 'Unknown error' });
        }
    }
)


const coinSlice = createSlice({
    name: 'coin',
    initialState: {
        isLoading: false,
        error: null
    },
    reducers: {
        clearErrors(state) {
            state.error = null
        }
    },
    extraReducers: builder => {
        builder

            .addCase(fetchSell.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchSell.rejected, (state, action) => {
                state.isLoading = false;
            
                // Если rejectWithValue с сервером, данные будут в action.payload
                if (action.payload?.message) {
                    state.error = action.payload.message;
                } else {
                    // fallback на стандартное сообщение
                    state.error = action.error?.message || "Возникла ошибка!";
                }
            })
            .addCase(fetchSell.fulfilled, (state) => {
                state.isLoading = false
            })
    }
});

export const {
    clearErrors
} = coinSlice.actions;

export default coinSlice.reducer

